export default __webpack_public_path__ + "static/media/mail-emoji.2559d9e2.svg";